import { render } from "./createdoctorView.vue?vue&type=template&id=e7c9d968&scoped=true"
import script from "./createdoctorView.vue?vue&type=script&lang=js"
export * from "./createdoctorView.vue?vue&type=script&lang=js"

import "./createdoctorView.vue?vue&type=style&index=0&id=e7c9d968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c9d968"]])

export default __exports__